import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.css';

function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('cookieConsent');
    if (!saved) {
      setVisible(true);
    }
  }, []);

  const handleConsent = (value) => {
    localStorage.setItem('cookieConsent', value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <p>
          We use cookies to keep the site secure and improve your experience.
          You can learn more in our{' '}
          <Link to="/privacy-policy#cookies">Cookie Policy</Link>.
        </p>
        <div className="cookie-actions">
          <button type="button" className="ghost-button" onClick={() => handleConsent('rejected')}>
            Reject
          </button>
          <button type="button" onClick={() => handleConsent('accepted')}>Accept</button>
        </div>
      </div>
    </div>
  );
}

export default CookieBanner;
